module.exports = __webpack_public_path__ + "img/internet.98ab6a49.png";